export const FEEDBACK_EMAIL = 'feedback@letscoparent.us';

// App store identifiers (see packages/mobile/eas.json ascAppId + app.json bundle/package).
export const APP_STORE_ID = '6761960413';
export const ANDROID_PACKAGE = 'com.letscoparent.app';

export function buildFeedbackMailto({ platform, version }) {
  const subject = 'coparent feedback';
  const body =
    `Hi coparent team,\n\n\n\n` +
    `— Sent from coparent ${platform} v${version}`;
  return `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/**
 * Deep link to the app's store listing, opened straight into the "write a review"
 * flow where the platform supports it. Used by the manual "Rate coparent" row; the
 * automatic in-app prompt uses the native StoreReview dialog instead.
 *
 * `platform` is 'iOS' | 'Android' (matches the strings passed to buildFeedbackMailto).
 */
export function buildStoreReviewUrl(platform) {
  if (platform === 'Android') {
    // market:// opens the Play Store app directly; if it isn't installed the caller's
    // Linking.openURL falls through to the browser via the https form below.
    return `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
  }
  return `https://apps.apple.com/app/id${APP_STORE_ID}?action=write-review`;
}
